(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ReactSimpleKeyboard", [], factory);
	else if(typeof exports === 'object')
		exports["ReactSimpleKeyboard"] = factory();
	else
		root["ReactSimpleKeyboard"] = factory();
})(window, function() {
return 